export const StepsRichiesta = {
	LANDING: 0,
	CONTATTI: 1,
	DATI_ANAGRAFICI: 2,
	PROFESSIONE: 3,
	SERVIZI_FACOLTATIVI: 4,
	RIEPILOGO: 5,
} as const

export type StepsSimulatore =
	(typeof StepsRichiesta)[keyof typeof StepsRichiesta]
